import React, { useState } from "react";
import { addDataCollectApi } from "../../../service/Apis";

export default function CollectData() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false); // Loader state
  const [error, setError] = useState(""); // Validation or API error message

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
    setError(""); // Clear errors when typing
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!formData.name.trim() || !formData.email.trim()) {
      setError("请输入姓名和电子邮箱");
      return;
    }

    // Simple email format check
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError("请输入有效的邮箱地址");
      return;
    }

    setLoading(true);
    try {
      let res = await addDataCollectApi(formData);
      res = res.data.data; // Adjust if API response is different
      console.log("API Response:", res);

      if (res.includes("already exist")) {
        setError("此电子邮件地址已存在，请使用其他电子邮件地址");
        setSubmitted(false);
        return;
      }

      // PDF download logic
      const pdfUrl =
        "https://newhopepoint.s3.us-east-2.amazonaws.com/0983_33_Danielle_ID_CHI_.pdf";

      window.open(pdfUrl, "_blank");

      // const response = await fetch(pdfUrl);
      // const blob = await response.blob();
      // const url = window.URL.createObjectURL(blob);

      // const link = document.createElement("a");
      // link.href = url;
      // link.download = "Danielle_ID_CHI.pdf";
      // document.body.appendChild(link);
      // link.click();
      // link.remove();
      // window.URL.revokeObjectURL(url);

      setSubmitted(true);
      setFormData({ name: "", email: "" });
    } catch (err) {
      console.error(err);
      setError("提交失败，请稍后再试");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="container-fluid d-flex align-items-center justify-content-center"
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(rgba(30,30,30,0.55), rgba(50,40,0,0.40)), url('images/harvard.jpg') center/cover no-repeat",
      }}
    >
      <div
        className="bg-light shadow-lg p-5 rounded-4"
        style={{ maxWidth: 500, width: "100%", opacity: 0.95 }}
      >
        <h2
          className="mb-4 text-center text-warning fw-bold"
          style={{ fontSize: "2.4rem", letterSpacing: ".1em" }}
        >
          基因传承必读
        </h2>

        <ul
          className="mb-4 px-2"
          style={{
            listStyle: "none",
            fontSize: "1.11rem",
            color: "#7b6700",
          }}
        >
          <li>🏛 当您有望族的梦想时</li>
          <li>😔 当您对现有孩子的成长感到遗憾时</li>
          <li>👨‍👦 当您希望有自己的血脉来监督家族企业时</li>
          <li>🎓 当您希望有多个孩子从常春藤名校毕业时</li>
          <li>🏳️‍🌈 当您和伴侣希望拥有属于你们的孩子时</li>
          <li>⏳ 当您已到高龄仍渴望迎接新生命时</li>
          <li>⏳ 当您的儿女还没有准备好为您添孙子时</li>
        </ul>

        <div className="mb-3 d-flex align-items-center">
          <span
            role="img"
            aria-label="mail"
            style={{ fontSize: "1.5rem", marginRight: 8 }}
          >
            📩
          </span>
          <span
            className="text-dark fw-semibold"
            style={{ fontSize: "1.1rem" }}
          >
            现在就填写信息，免费获取《辅助生育全程指导手册》
          </span>
        </div>

        {/* Error message */}
        {error && (
          <div className="alert alert-danger py-2">{error}</div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          <div className="row g-3">
            <div className="col-12">
              <label htmlFor="name" className="form-label fw-semibold">
                姓名：
              </label>
              <input
                type="text"
                id="name"
                className="form-control rounded-3"
                placeholder="请输入您的姓名"
                value={formData.name}
                onChange={handleChange}
                disabled={loading}
                required
              />
            </div>

            <div className="col-12">
              <label htmlFor="email" className="form-label fw-semibold">
                电子邮箱：
              </label>
              <input
                type="email"
                id="email"
                className="form-control rounded-3"
                placeholder="请输入您的电子邮箱"
                value={formData.email}
                onChange={handleChange}
                disabled={loading}
                required
              />
            </div>
          </div>

          <button
            type="submit"
            className="btn btn-warning w-100 mt-4 fw-bold d-flex justify-content-center align-items-center"
            style={{ letterSpacing: ".04em", height: "45px" }}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                正在提交...
              </>
            ) : (
              "提交"
            )}
          </button>
        </form>

        {submitted && (
          <div className="alert alert-success mt-4 rounded-3">
            🎉 提交成功！PDF 已下载
          </div>
        )}
      </div>
    </div>
  );
}
